export const formatCel = (cel) => {
	if (!cel) return null;
	return cel.toString().replace(/\B(?=(\d{6})+(?!\d))/g, "-");

}